import { useEffect, useContext, useCallback } from 'react';

import { seeMessage, seeMessages } from 'actions/messages';

import { useCurrentUserId } from 'shared-hooks/user';

import { IdleContext } from 'context/IdleContext';

import { Message } from 'types';

interface MessageSeenerProps {
    messages: Message[],
    enabled: boolean
}

const MessageSeener = ({ messages, enabled }: MessageSeenerProps) => {
    const idleCtx = useContext(IdleContext);
    const currentUserId = useCurrentUserId();

    const attemptSee = useCallback(() => {
        const messagesToSee = messages.filter(message => message.author && message.author !== currentUserId && !message.seen_by?.includes(currentUserId))

        if (!messagesToSee.length) {
            return;
        }

        if (idleCtx?.isIdle) {
            return;
        }

        if (!enabled) {
            return;
        }

        seeMessages(messagesToSee.map(({ id }) => id), currentUserId);

        // seeMessage(messageId);
    }, [messages, currentUserId, idleCtx?.isIdle, enabled]);

    useEffect(() => {
        attemptSee();
    }, [attemptSee]);

    return null;
}

export default MessageSeener;
